export default "__VITE_ASSET__dfK0m7vi__"